import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { SEO_CITIES, SEO_COMMUNITIES } from "@/pages/CityPage";
import { slugify } from "@/lib/countries";
import { usePrefs } from "@/lib/prefs";

const GLOBAL = ["United States", "United Kingdom", "Canada", "United Arab Emirates", "Australia", "Germany", "France", "Nigeria", "Brazil", "Japan"];

export default function Footer() {
  const { t } = usePrefs();
  return (
    <footer className="border-t border-amber-500/15 bg-[#06070A]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 grid gap-8 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            <Heart className="w-4 h-4 text-amber-400" fill="currentColor" />
            <span className="font-display text-xl gold-text font-semibold">Vivaah Royale</span>
          </div>
          <p className="text-sm text-slate-400 mt-3 max-w-xs" data-testid="footer-tagline">{t("ftTag")}</p>
          <div className="text-sm text-slate-400 space-y-2 mt-5">
            <Link to="/browse" className="block hover:text-amber-200">{t("ftBrowse")}</Link>
            <Link to="/plans" className="block hover:text-amber-200">{t("ftPlans")}</Link>
            <Link to="/invite" className="block hover:text-amber-200">{t("ftInvite")}</Link>
          </div>
        </div>
        <nav className="md:col-span-2" aria-label="Matrimony by city">
          <p className="text-xs uppercase tracking-widest text-amber-400 mb-3">{t("ftCity")}</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 text-sm text-slate-400">
            {SEO_CITIES.map((c) => <Link key={c} to={`/matrimony/${c.toLowerCase()}`} className="hover:text-amber-200" data-testid={`footer-city-${c.toLowerCase()}`}>{c} Matrimony</Link>)}
          </div>
          <p className="text-xs uppercase tracking-widest text-amber-400 mt-6 mb-3">{t("ftCommunity")}</p>
          <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-slate-400">
            {SEO_COMMUNITIES.map((c) => <Link key={c} to={`/matrimony/${c.toLowerCase()}`} className="hover:text-amber-200">{c} Matrimony</Link>)}
          </div>
          <p className="text-xs uppercase tracking-widest text-amber-400 mt-6 mb-3">{t("ftWorld")}</p>
          <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-slate-400">
            {GLOBAL.map((c) => <Link key={c} to={`/country/${slugify(c)}`} className="hover:text-amber-200" data-testid={`footer-country-${slugify(c)}`}>{c}</Link>)}
            <Link to="/countries" className="text-amber-300">{t("ftAll")}</Link>
            <Link to="/stories" className="text-amber-300">{t("ftStories")}</Link>
          </div>
        </nav>
        <p className="text-xs text-slate-500 leading-relaxed">{t("ftNote")}</p>
      </div>
    </footer>
  );
}
